/**
 * Système de logging conditionnel pour environnements dev/production
 * - En développement : tous les logs sont actifs
 * - En production : seuls warn et error sont actifs
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  /**
   * Logs de débogage (visible uniquement en dev)
   * Usage: informations détaillées pour le debugging
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Logs d'information (visible uniquement en dev)
   * Usage: flux général de l'application
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * Logs d'avertissement (toujours visible)
   * Usage: situations anormales mais non-critiques
   */
  warn: (...args: any[]) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Logs d'erreur (toujours visible)
   * Usage: erreurs qui nécessitent une attention
   */
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  },
};
